module.exports = __webpack_public_path__ + "img/1562654637.b497de16.jpg";